module.exports = __webpack_public_path__ + "static/img/wdm.c5728325.png";